import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

function ClientSignin() {
  const { search } = useLocation();
  const redirect_url = new URLSearchParams(search).get("redirect_url");

  const checkLogout = async () => {
    try {
      const code = window.localStorage.getItem("authfast");

      if (code) {
        await fetch(`${process.env.REACT_APP_API_URL}/auth/user/signout`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accepts: "application/json",
          },
          body: JSON.stringify({ code }),
        });
      }

      // Clear token
      window.localStorage.removeItem("authfast");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user_info");

      // Redirect safely
      if (redirect_url) {
        window.location.href = `${redirect_url}?logout=true`;
      } else {
        window.location.href = "/?logout=true";
      }
    } catch (err) {
      console.log("logout-err", err);
    }
  };

  useEffect(() => {
    checkLogout();
  }, []);

  return (
    <div className="bg-gradient-to-br from-rose-50 to-white h-screen flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="bg-white rounded-3xl shadow-xl p-10 w-full max-w-md text-center"
      >
        <motion.div
          initial={{ rotate: -10 }}
          animate={{ rotate: 10 }}
          transition={{
            duration: 1.6,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          className="mx-auto w-20 h-20 bg-rose-100 rounded-full flex items-center justify-center shadow-inner"
        >
          {/* Logout Icon */}
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9B1C22"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M16 17L21 12L16 7" />
            <path d="M21 12H9" />
            <path d="M12 19C12 20.1 11.1 21 10 21H7C5.9 21 5 20.1 5 19V5C5 3.9 5.9 3 7 3H10C11.1 3 12 3.9 12 5" />
          </svg>
        </motion.div>

        <h1 className="text-2xl font-semibold mt-6">Signing you out…</h1>
        <p className="text-slate-500 mt-2 text-sm">
          Please wait while we securely end your session.
        </p>

        {/* Loading indicator */}
        <motion.div
          className="mt-6 flex justify-center gap-2"
          initial="hidden"
          animate="show"
          variants={{
            show: {
              transition: { staggerChildren: 0.15 },
            },
          }}
        >
          {[1, 2, 3].map((i) => (
            <motion.span
              key={i}
              className="w-3 h-3 bg-rose-600 rounded-full"
              variants={{
                hidden: { y: 0, opacity: 0.4 },
                show: {
                  y: -6,
                  opacity: 1,
                  transition: {
                    duration: 0.5,
                    repeat: Infinity,
                    repeatType: "reverse",
                  },
                },
              }}
            />
          ))}
        </motion.div>
      </motion.div>
    </div>
  );
}

export default ClientSignin;
